import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingHighlighProductRoot = styled("section")<{}>(() => {
  return css`
    .landing-action-button {
      @media ${responsiveMap.maxLg} {
        width: 100%;
      }
    }

    .top-container {
      @media ${responsiveMap.maxLg} {
        margin-bottom: 32px;
      }
    }
  `;
});
